import {
  put, putResolve, take, takeLatest, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import { LoadingActionTypes as types } from 'app/ducks/loading/types';
import {
  success, error, info, warning,
} from 'react-notification-system-redux';

function* actionConfirmedSaga(action): any {
  const payload = {
    title: action.payload.text,
    position: 'tc',
  };
  if (action.payload.type === 'success') {
    yield put(success(payload));
  }
  if (action.payload.type === 'error') {
    yield put(
      error(payload),
    );
  }
  if (action.payload.type === 'info') {
    yield put(info(payload));
  }
  if (action.payload.type === 'warning') {
    yield put(
      warning(payload),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* actionConfirmedSagaWatcher(): any {
  yield takeLatest(types.ACTION_CONFIRMED, actionConfirmedSaga);
}

export default function* root(): any {
  yield all([actionConfirmedSagaWatcher()]);
}
